module.exports = __webpack_public_path__ + "static/media/logo--blue.650aa155.svg";